export default {"src":"/_next/static/media/innovate_withInsight.fc0a06ac.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};